<template>
  <div class="has-shadow bg-white is-rounded result result-box" @click.prevent="showDetails">
    <span class="tracking-number">{{ trackingNumber }}</span>
    <div class="columns">
      <Sender :result="result" class="is-third" />
      <Recipient :result="result" class="is-third" />
      <Details :result="result" class="is-third" />
    </div>
    <div class="columns mt-3 card-footer">
      <div class="is-half">
        <span class="label status" :class="statusCode">{{ $lang.translate('track.label.status') }}: {{ statusText }}</span>
        <span v-if="result.damages.length" class="label alert"><i class="icon-alert text-white mr-1"></i> {{ $lang.translate('track.label.deviation') }}</span>
      </div>
      <div class="is-half text-right">
        <a class="read-more" href="#" @click.prevent="showDetails">{{ $lang.translate('track.link.seeDetails') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Sender from '@/components/result/Sender'
import Recipient from '@/components/result/Recipient'
import Details from '@/components/result/Details'
import { getters } from '@/store'
import { cleanUrlParam } from '@/utils'

export default {
  name: 'Result',
  props: {
    result: {
      type: Object,
      required: true
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    status () {
      if (this.result.orderStatuses.length > 0) {
        return this.result.orderStatuses[0]
      }
      return null
    },
    statusText () {
      if (this.statusCode == 'ontheway') {
        return this.status.statusText + ' (' + this.deliveredPackages.length + '/' + this.result.packages.length + ')'
      }
      return this.status.statusText
    },
    deliveredPackages() {
      return getters.deliveredPackages(this.result)
    },
    statusCode () {
      if (this.status) {
        if (this.status.status == 'delivered' && this.result.packages.length > 1) {
          return this.result.packages.length == this.deliveredPackages.length ? 'delivered' : 'ontheway'
        }
        return this.status.status
      }
      return 'unknown'
    },
    trackingNumber () {
      return this.result.details.freightBillNo + ' - ' + this.result.details.senderReference
    }    
  },
  methods: {
    showDetails() {
      const query = this.searchKey ? { key: this.searchKey } : {}
      this.$router.push({name: 'resultDetail', params: {id: cleanUrlParam(this.result.details.uniqueId) }, query })
    }
  },
  components: {
    Sender,
    Recipient,
    Details
  }
}
</script>

<style>
.result-box {
  padding: 30px 40px;
  font-size: 16px;
  margin-bottom: 30px;
}

.result h4 {
  font-size: 23px;
  margin-bottom: 10px;
}

.result .tracking-number {
  display: block;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 0.75rem;
}


.result .label {
  display: inline-block;
  padding: 14px 25px;
  border-radius: 50px;
  background-color: #D3D3D3;
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
  margin-right: 0.5rem;
}

@media(max-width: 1023px) {
  .result-box {
    padding: 15px 20px;
  }
  
  .result .tracking-number {
    font-size: 20px;
  }

  .result .label {
    margin-bottom: 0.5rem;
    font-size: 18px;
  }
}

.result .label.delivered {
  background-color: #AAD51E;
}

.result .label.alert {
  background-color: #F46113;
}

.result .label.ontheway {
  background-color: #f39623;
}

.result .card-footer {
  align-items: flex-end;
}

.result .card-footer .read-more {
  font-size: 20px;
}

.result h4 > i {
  margin-right: 1.3rem;
  position: relative;
  top: 3px;
}
</style>

<style scoped>
.result-box {
  cursor: pointer;
}
</style>